export default [
  {
    path: 'fees',
    name: 'statistics-fees',
    component: () => import(/* webpackChunkName: "statistics-fees" */ '~/views/StatisticsFees/StatisticsFees.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
  {
    path: 'trades',
    name: 'statistics-trades',
    component: () => import(/* webpackChunkName: "statistics-trades" */ '~/views/StatisticsTrades/StatisticsTrades.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
  {
    path: 'requisites',
    name: 'statistics-requisites',
    component: () => import(/* webpackChunkName: "statistics-requisites" */ '~/views/StatisticsRequisites/StatisticsRequisites.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
  {
    path: 'merchants',
    name: 'statistics-merchants',
    component: () => import(/* webpackChunkName: "statistics-merchants" */ '~/views/StatisticsMerchants/StatisticsMerchants.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
  {
    path: 'traders',
    name: 'statistics-traders',
    component: () => import(/* webpackChunkName: "statistics-traders" */ '~/views/StatisticsTraders/StatisticsTraders.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
  {
    path: 'referrals',
    name: 'statistics-referrals',
    component: () => import(/* webpackChunkName: "statistics-referrals" */ '~/views/StatisticsReferrals/StatisticsReferrals.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
  {
    path: 'transactions',
    name: 'statistics-transactions',
    component: () => import(/* webpackChunkName: "statistics-transactions" */ '~/views/StatisticsTransactions/StatisticsTransactions.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderStatistics' },
    },
  },
];
